export const ROUND_COORDINATE = 6;
export const ROUND_SENSOR_VALUE = 2;
export const PHONE_NUMBER_REGEXP = /^(?!.*[a-zA-Z])\+?\d{5,14}$/;
export const EMAIL_REGEXP = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const LOCAL_STORAGE_KEYS = {
  VISIBLE_OBJECTS_NAME: 'user_name_on_map',
  VISIBLE_GEOZONES_LAYER: 'geozone_layer_on_map',
  VISIBLE_GEOZONES_NAME: 'geozone_name_on_map',
  VISIBLE_DEVISES_LAYER: 'devices_layer_on_map',
  VISIBLE_DEVICES_NAME: 'devices_name_on_map',
  OBJECT_CLUSTERING_SETTINGS: 'object_clustering_settings',
} as const;
